export default "__VITE_ASSET__BFg2xEDl__"